// extracted by mini-css-extract-plugin
export default {"wrapper":"FileSummary_wrapper__yHWcT","icon":"FileSummary_icon__ZgDV0","panel":"FileSummary_panel__Fa05k","title":"FileSummary_title__ehS2n"};